import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"
import { withRouter, Link } from "react-router-dom"
import { connect } from "react-redux"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Input,
  Spinner,
  Table,
} from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import PropTypes from "prop-types"
//import { ReactSearchAutocomplete } from "react-search-autocomplete"
import { isEmpty } from "lodash"
import moment from "moment"
import ButtonSpinner from "../../../components/ButtonSpinner"
//Import Styles
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"

import ToolkitProvider from "react-bootstrap-table2-toolkit"
import SimpleReactValidator from "simple-react-validator"
import { ToastContainer, toast } from "react-toastify"

//components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import * as copyDataAction from "../../../store/ZGF0YUNvcHlEZWxldGVk/actions"
import Modal from "react-bootstrap/Modal"
import api from "helpers/Api"
//DataCopyDeleted
const DataCopyDeleted = (props) => {
  // const { SearchBar } = Search
  const title = "Data Copy Deleted"
  const { dispatch, searchBtnStyle } = props

  useEffect(() => {
    dispatch(copyDataAction.loadRecordsMetaData())

    dispatch(
      copyDataAction.loadDataCopy({
        page: 1,
        limit: 50,
      })
    )
  }, [])
  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate

  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormat = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""


  const simpleUploadValidator = useRef(new SimpleReactValidator())
  const [, forceUpload] = useState()
  //Reducer store state maintenance
  const specificDispatch = useDispatch()

  const eventCompleteUpdate = useSelector((state) => state.dataCopyDeleted)

  const { recordsMetaData = {}, data_copy_details = [], data_link_details = [] } = eventCompleteUpdate

  console.log(data_copy_details, "copyDetails")
  // initial state
  const [copyData, setCopyData] = useState({
    company: [],
    branch: [],
    department: [],
    fromDate: "",
    toDate: "",
    leadNo: "",
    copiedFromDate: "",
    copiedToDate: ""
  })

  //handle change
  const handleChange = async (e) => {
    setCopyData({ ...copyData, [e.target.name]: e.target.value })
  }


  //reset functionalities
  const resetForm = () => {

    setCopyData({
      fromDate: "",
      toDate: "",
      leadNo: "",

    })

    dispatch(
      copyDataAction.loadDataCopy({
        page: 1,
        limit: 50,
      })
    )
  }

  //button spinner state
  const [btnLoader, setBtnLoader] = useState(false)
  //dropdown options


  const [pageCount, setPageCount] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [pageChange, setPageChange] = useState(false)

  //Search value
  const [searchValueList, setSearchValueList] = useState({})
  const [searchFilter, setSearchFilter] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  const searchValue =
    !isEmpty(searchValueList) && isEmpty(searchInput)
      ? searchValueList
      : isEmpty(searchValueList) && isEmpty(searchInput)
        ? {
          page: pageChange ? pageCount : 1,
          limit: 50,

        }
        : {
          page: pageChange ? pageCount : 1,
          limit: 50,
          searchFilter: searchInput,
        }

  //apply filter submit

  const applyFilter = (e) => {
    e.preventDefault()

    var searchFromDate =
      copyData && copyData.fromDate
        ? moment(copyData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      copyData && copyData.toDate
        ? moment(copyData.toDate).format("YYYY-MM-DD")
        : ""

    var searchLeadNo = copyData && copyData.leadNo ? copyData.leadNo : ""

    var searchvalue = {}
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = sizePerPage ? sizePerPage : 50

    if (searchFromDate) {
      searchvalue.eventStartDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventEndDate = searchToDate
    }

    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }

    setSearchValueList(searchvalue)
    setBtnLoading(true)
    specificDispatch(copyDataAction.loadDataCopy(searchvalue))
    setTimeout(() => {
      setBtnLoader(false)
      setBtnLoading(false)
    }, 2000)
  }

  const [uploadQcData, setUploadQcData] = useState({
    description: ""
  })
  const handleQC = async (e) => {
    setUploadQcData({ ...uploadQcData, [e.target.name]: e.target.value })
  }
  const [updateLinkModal, setUpdateLinkModal] = useState(false)
  const [leadId, setLeadId] = useState("")
  //data table
  const [renderPage, setRenderPage] = useState(false)
  //deleteStatus
  const [deleteStatusModal, setDeleteStatusModal] = useState(false)
  const [deleteStatusData, setDeleteStatusData] = useState({
    remarks: ""
  })
  const handleDeleteChange = (e) => {
    setDeleteStatusData({ ...deleteStatusData, [e.target.name]: e.target.value })
  }
  let slNo = 0
  const copyDataTable =
    !isEmpty(data_copy_details) && data_copy_details.data.length > 0
      ? data_copy_details.data.map((copyData, index) => {
        slNo = slNo + 1


        const colorCode =
          !isEmpty(recordsMetaData) &&
            recordsMetaData.processStatusOptions &&
            recordsMetaData.processStatusOptions.length > 0 ?
            recordsMetaData.processStatusOptions.find(
              (_) => _.processStatusId === copyData.dataProcessStatus

            ) &&
            recordsMetaData.processStatusOptions.find(
              (_) => _.processStatusId === copyData.dataProcessStatus

            ) : ""
        const nasColorCode = !isEmpty(recordsMetaData) &&
          recordsMetaData.processStatusOptions &&
          recordsMetaData.processStatusOptions.length > 0 ?
          recordsMetaData.processStatusOptions.find(
            (_) => _.processStatusId === copyData.nasProcessStatus

          ) &&
          recordsMetaData.processStatusOptions.find(
            (_) => _.processStatusId === copyData.nasProcessStatus

          ) : ""
        const qcRemarkValue =
          !isEmpty(copyData.qcUploadLinkDetails) &&
            copyData.qcUploadLinkDetails.length > 0 &&
            copyData.qcUploadLinkDetails[copyData.qcUploadLinkDetails.length - 1] &&
            copyData.qcUploadLinkDetails[copyData.qcUploadLinkDetails.length - 1].qcRemarks !== undefined &&
            copyData.qcUploadLinkDetails[copyData.qcUploadLinkDetails.length - 1].qcRemarks !== null
            ? copyData.qcUploadLinkDetails[copyData.qcUploadLinkDetails.length - 1].qcRemarks
            : ""
        const eventNameValue = !isEmpty(copyData.eventName) && copyData.eventName.length > 0 ?
          copyData.eventName.map((m) => m).join(",") : ""
        const eventDateValue = !isEmpty(copyData.eventDate) && copyData.eventDate.length > 0 ?
          copyData.eventDate.map((m) => moment(m).format(dateFormat)).join(",") : ""
        const operationColorCode =
          !isEmpty(recordsMetaData) &&
            recordsMetaData.processStatusOptions &&
            recordsMetaData.processStatusOptions.length > 0 ?
            recordsMetaData.processStatusOptions.find(
              (_) => _.processStatusId === copyData.operationProcessStatus

            ) &&
            recordsMetaData.processStatusOptions.find(
              (_) => _.processStatusId === copyData.operationProcessStatus

            ) : ""
        return {
          _id: copyData._id,
          sNo: slNo,
          index: index,
          leadNo: copyData.leadNo,
          leadId: copyData.leadId,
          branchName: copyData.branchName,
          routeData: copyData,
          clientName: copyData.clientName,
          clientId: copyData.clientId,
          companyName: copyData.companyName,
          leadServiceName: copyData.leadServiceName,
          leadSourceName: copyData.leadSourceName,
          leadType: copyData.leadType,
          salesUrge: copyData.salesUrge,
          colorCode: !isEmpty(colorCode) ? colorCode.colorCode : "",
          operationColorCode: !isEmpty(operationColorCode) ? operationColorCode.colorCode : "",
          key: index,
          mobileNo: copyData.clientContact ? copyData.clientContact : "--",
          cpProfile: copyData.cpStatus ? copyData.cpStatus : "--",
          cpRemarks: copyData.cpRemarks ? copyData.cpRemarks : "--",
          brideName: copyData.brideName ? copyData.brideName : "--",
          groomName: copyData.groomName ? copyData.groomName : "--",
          services: copyData.noOfservice ? copyData.noOfservice : 0,
          pendingStatus: copyData.pendingStatus
            ? copyData.pendingStatus
            : "--",
          overAllStatus: copyData.dataOverAllStatus ? copyData.dataOverAllStatus : "",
          dataStatus: copyData.dataProcessStatusName
            ? copyData.dataProcessStatusName
            : "DATA COPY PENDING",
          uploadLinkDetails: copyData.uploadLinkDetails,
          uploadStatus: copyData.uploadStatus ? copyData.uploadStatus : "--",
          uploadQc: copyData.uploadQc ? copyData.uploadQc : "--",
          qcUploadLinkProcessStatus: copyData.qcUploadLinkProcessStatus ? copyData.qcUploadLinkProcessStatus : "",
          qcUploadLinkProcessStatusName: copyData.qcUploadLinkProcessStatusName ? copyData.qcUploadLinkProcessStatusName : "",
          qcRemark: qcRemarkValue,
          eventDate: eventDateValue,
          eventName: eventNameValue,
          nasColorCode: !isEmpty(nasColorCode) ? nasColorCode.colorCode : "",
          nasProcessStatusName: copyData.nasProcessStatusName ? copyData.nasProcessStatusName
            : "Pending",
          serviceArray: !isEmpty(copyData.serviceRecord) ? copyData.serviceRecord : [],
          operationProcessStatusName: copyData.operationProcessStatusName,
          deleteStatus: copyData.dataDeleteStatus ? copyData.dataDeleteStatus : "",
          opsStatus: copyData.opsStatus ? copyData.opsStatus : '',
          copiedDate: copyData.dataCopiedOn ? moment(copyData.dataCopiedOn).format(dateFormat) : "--",
          crmName: copyData.crmName ? copyData.crmName : "--",
          serviceDetails: copyData.serviceDetails,
          nasLinkCount: copyData.nasLinkCount
        }
      })
      : []



  // const { ExportCSVButton } = CSVExport
  const updateLinkList = (row) => {
    const record = {
      leadId: row.leadId
    }
    dispatch(copyDataAction.loadDataLinkList(record))

  }
  // const [addUpdateLinkData, setAddUpdateLinkData] = useState()
  const [pendingModal, setPendingModal] = useState(false)
  //pending status

  const [pendingData, setPendingData] = useState("")

  const getCellStyle = (row) => {
    const deleteStatus = row.deleteStatus
    const operationStatus = row.operationProcessStatusName

    if (deleteStatus == "PENDING" && operationStatus == "CLIENT COMPLETED") {
      return {
        backgroundColor: "#f78f8f",
      }
    } else if (deleteStatus == "COMPLETED" && operationStatus == "CLIENT COMPLETED") {
      return {
        backgroundColor: "#3abd856e",
      }
    } else {
      return {
        backgroundColor: "",
      }
    }

  }

  const getCellStyleWithText = (row) => {
    const deleteStatus = row.deleteStatus
    const operationStatus = row.operationProcessStatusName

    if (deleteStatus == "PENDING" && operationStatus == "CLIENT COMPLETED") {
      return {
        backgroundColor: "#f78f8f",
        color: "#e40d8c",
        textTransform: "uppercase",
      }
    } else if (deleteStatus == "COMPLETED" && operationStatus == "CLIENT COMPLETED") {
      return {
        backgroundColor: "#3abd856e",
        color: "#e40d8c",
        textTransform: "uppercase",
      }
    } else {
      return {
        backgroundColor: "",
        color: "#e40d8c",
        textTransform: "uppercase",
      }
    }

  }
  //columns for data table
  const initialColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      style: (cell, row) => getCellStyle(row),
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      csvExport: false,
      hidden: false,
      formatter: (cellContent, row) => {
        const leadData = row.routeData
        return (
          <Link
            to={{
              pathname: `/client-details/${row.leadId}`,
              state: {
                row: leadData,
                mode: "Data",
                leadClientId: leadData,

              },
            }}
          >
            <span>{row.leadNo}</span>
          </Link>
        )
      },
      style: (cell, row) => getCellStyleWithText(row),
      headerStyle: {
        minWidth: "145px",
      },
    },

    {
      dataField: "companyName",
      text: "Company Name",
      hidden: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch Name",
      hidden: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "clientName",
      text: "Client Name ",
      hidden: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "crmName",
      text: "Crm Name",
      hidden: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "165px",
      },
    },

    {
      dataField: "mobileNo",
      text: "Mobile No",
      hidden: true,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "cpProfile",
      text: "CP Profile",
      hidden: true,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "cpRemarks",
      text: "CP Remarks",
      hidden: true,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "eventName",
      text: "Event Name",
      style: (cell, row) => getCellStyle(row),
      hidden: false,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "eventDate",
      text: "Event Date",
      hidden: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "brideName",
      text: "Bride Name",
      style: (cell, row) => getCellStyle(row),
      hidden: false,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "groomName",
      text: "Groom Name",
      hidden: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "copiedDate",
      text: "Copied Date",

      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "160px",
      },
      hidden: false,
    },

    {
      dataField: "overallStatus",
      text: "Overall Status",
      hidden: false,
      style: (cell, row) => getCellStyleWithText(row),
      formatter: (cellContent, row) => {

        return (
          <div className="space-between">
            {!isEmpty(row.overAllStatus) ? (
              <span>{row.overAllStatus}</span>
            ) : (
              <span style={{ color: "#E40D8C" }}>Pending</span>
            )}
          </div>
        )
      },
      headerStyle: {
        minWidth: "180px",
      },
    },
    {
      dataField: "pendingStatus",
      text: "Pending Status",
      hidden: false,
      style: (cell, row) => getCellStyle(row),
      formatter: (cellContent, row) => {
        const service = row.serviceArray
        const serviceCount = !isEmpty(service) && service.length > 0 ? service.length : 0
        return (
          <div className="d-flex flex-row align-items-center">
            <i
              onClick={() => {
                setPendingModal(true)
                setPendingData(service)
                setLeadId(row.leadId)
              }}
              className="fas fa-eye"
              style={{ color: "#50a5f1", fontSize: "16px", }}
            ></i>
            <div style={{ marginLeft: "40px" }}>
              <span className="badge rounded-pill bg-primary">
                {serviceCount}
              </span>
            </div>
          </div>
        )
      },
      headerStyle: {
        minWidth: "180px",
      },
    },
    {
      dataField: "dataStatus",
      text: "Copy Status",
      hidden: false,
      formatter: (cellContent, row) => {
        const colorCode = !isEmpty(row.colorCode) ? row.colorCode : "#B042F5"
        return (
          <div className="space-between">
            {!isEmpty(row.dataStatus) ? (
              <button
                style={{
                  background: colorCode,
                  border: "none",
                  cursor: "pointer",
                  color: "white",
                  padding: "2px",
                  borderRadius: "4px",
                }}
              >
                {row.dataStatus}
              </button>
            ) : (
              "--"
            )}

          </div>
        )
      },
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "nasLinkStatus",
      text: "Nas Link Status",
      hidden: false,
      formatter: (cellContent, row) => {
        const colorCode = !isEmpty(row.nasColorCode) ? row.nasColorCode : ""
        return (
          <div className="space-between">
            {!isEmpty(row.nasProcessStatusName) ? (
              <Button
                style={{
                  background: colorCode,
                  border: "none",
                  cursor: "pointer",
                  color: "white",
                  padding: "2px",
                  borderRadius: "4px",
                }}
                className={!isEmpty(colorCode) ? "" : "btn btn-danger"}
              >
                {row.nasProcessStatusName}
              </Button>
            ) : (
              "--"
            )}

          </div>
        )
      },
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "uploadLink",
      text: "Nas Link",
      hidden: false,
      style: (cell, row) => getCellStyle(row),
      formatter: (cellContent, row) => {
        const serviceCount = row.nasLinkCount || 0
        return (
          <div>
            <Button
              className="btn btn-success"
              onClick={() => {
                handleHideMessages()
                setUpdateLinkModal(true)
                updateLinkList(row)

              }}
            >
              Nas Link ({serviceCount})
            </Button>
          </div>
        )
      },
      headerStyle: {
        minWidth: "155px",
      },
    },

  ]

  const [columns, setColumns] = useState(initialColumns)
  const [columnModal, setColumnModal] = useState(false)

  const [oddColumnData, setOddColumnData] = useState([])
  const [evenColumnData, setEvenColumnData] = useState([])
  useEffect(() => {
    if (columns && columns.length > 0) {
      var array = columns
      var evenColumns = []
      var oddColumns = []

      for (var i = 0; i < array.length; i++) {
        if (i % 2 === 0) {
          oddColumns.push(array[i])
        } else {
          evenColumns.push(array[i])
        }
      }

      setOddColumnData(oddColumns)
      setEvenColumnData(evenColumns)
    }
  }, [columns])

  const selectColumn = columns
    .filter((column) => column.hidden === false)
    .map((column) => column.dataField)

  const [selectedColumns, setSelectedColumns] = useState(selectColumn)

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target

    let updatedSelectedColumns
    if (checked) {
      updatedSelectedColumns = [...selectedColumns, value]
    } else {
      updatedSelectedColumns = selectedColumns.filter(
        (column) => column !== value
      )
    }

    setSelectedColumns(updatedSelectedColumns)
  }

  //  "Select All" checkbox
  const handleSelectAllChange = (e) => {
    const { checked } = e.target
    if (checked) {
      const allColumns = columns.map((column) => column.dataField)
      setSelectedColumns(allColumns)
    } else {
      const restoredColumns = initialColumns
        .filter((column) => !column.hidden)
        .map((column) => column.dataField)
      setSelectedColumns(restoredColumns)
    }
  }

  const handleSaveColumns = () => {
    setColumnModal(false)

    const updatedColumns = columns.map((column) => {
      const isColumnSelected = selectedColumns.includes(column.dataField)
      return { ...column, hidden: !isColumnSelected }
    })

    setColumns(updatedColumns)
    // default columns
    const defaultColumns = initialColumns.filter((column) => !column.hidden)
    const selectedNonDefaultColumns = selectedColumns.filter(
      (column) =>
        !defaultColumns.some(
          (defaultColumn) => defaultColumn.dataField === column
        )
    )

    if (selectedNonDefaultColumns.length > 0) {
      toast.success("New Columns added successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }
  }

  const handleRestoreToDefault = () => {
    const restoreColumns = initialColumns
      .filter((column) => !column.hidden)
      .map((column) => column.dataField)

    setSelectedColumns(restoreColumns)
  }


  const handleHideMessages = () => {
    // simpleValidator.current.hideMessages()
    simpleUploadValidator.current.hideMessages()
    setRenderPage(!renderPage)
  }

  //Search filter

  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    dispatch(
      copyDataAction.loadDataCopy({
        searchFilter: searchInput,
        page: pageChange ? pageCount : 1,
        limit: 50,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {

    var searchFromDate =
      copyData && copyData.fromDate
        ? moment(copyData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      copyData && copyData.toDate
        ? moment(copyData.toDate).format("YYYY-MM-DD")
        : ""

    var searchLeadNo = copyData && copyData.leadNo ? copyData.leadNo : ""

    var searchvalue = {}


    if (searchFromDate) {
      searchvalue.eventStartDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventEndDate = searchToDate
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }

    //

    setPageLoad(!pageLoad)
    setDownloadLoading(true)
    api
      .post(`/get-data-copy-scheduling-deleted-excel-export`, searchvalue)
      .then((response) => {
        const copyExportDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((copyData, index) => {
            const eventName = !isEmpty(copyData.eventName) && copyData.eventName.length > 0 ?
              copyData.eventName.map((m) => m).join(",") : ""
            const eventDate = !isEmpty(copyData.eventDate) && copyData.eventDate.length > 0 ?
              copyData.eventDate.map((m) => moment(m).format(dateFormat)).join(",") : ""
            const eventNameValue = !isEmpty(eventName)
              ? JSON.stringify(eventName).replace(/","/g, "\n")
              : "--"
         
            const eventDateValue =!isEmpty(eventDate) 
            ? JSON.stringify(eventDate).replace(/","/g, "\n")
            : "--"
            return {
              _id: copyData._id,
              sNo: index + 1,
              index: index,
              leadNo: copyData.leadNo,
              leadId: copyData.leadId,
              branchName: copyData.branchName,
              routeData: copyData,
              clientName: copyData.clientName ? copyData.clientName : "--",
              clientId: copyData.clientId,
              companyName: copyData.companyName,
              leadServiceName: copyData.leadServiceName,
              leadSourceName: copyData.leadSourceName,
              leadType: copyData.leadType,
              salesUrge: copyData.salesUrge,
              key: index,
              mobileNo: copyData.clientContact ? copyData.clientContact : "--",
              cpProfile: copyData.cpStatus ? copyData.cpStatus : "--",
              cpRemarks: copyData.cpRemarks ? copyData.cpRemarks : "--",
              brideName: copyData.brideName ? copyData.brideName : "--",
              groomName: copyData.groomName ? copyData.groomName : "--",
              services: copyData.noOfservice ? copyData.noOfservice : 0,
              //pendingStatus
              pendingStatus: copyData.pendingStatus
                ? copyData.pendingStatus
                : "--",
              overAllStatus: copyData.dataOverAllStatus ? copyData.dataOverAllStatus : "Pending",
              dataStatus: copyData.dataProcessStatusName
                ? copyData.dataProcessStatusName
                : "DATA COPY PENDING",
              uploadLinkDetails: copyData.uploadLinkDetails,
              uploadStatus: copyData.uploadStatus ? copyData.uploadStatus : "--",
              eventDate: eventDateValue,
              eventName: eventNameValue,
              nasProcessStatusName: copyData.nasProcessStatusName ? copyData.nasProcessStatusName : "Pending",
              operationProcessStatusName: copyData.opsStatus || "--",
              deleteStatus: copyData.dataDeleteStatus ? copyData.dataDeleteStatus : "",
              copiedDate: copyData.dataCopiedOn ? moment(copyData.dataCopiedOn).format(dateFormat) : "--",
              crmName: copyData.crmName ? copyData.crmName : "--"
            }
          })
          : []
        setTimeout(() => {
          let headerData = [
            "SNo,Lead No,  Company , Branch,Client Name,CRM Name,Mobile No,CP Profile,CP Remarks,Event Name,Event Date,Groom Name,Bride Name,Copied Date,Overall Status,Pending Status,Copy Status,NasLink Status",
          ]

          let usersCsv =
            !isEmpty(copyExportDataTable) &&
            copyExportDataTable.reduce((acc, user) => {
              const {
                sNo,
                leadNo,
                companyName,
                branchName,
                clientName,
                crmName,
                mobileNo,
                cpProfile,
                cpRemarks,
                eventName,
                eventDate,
                groomName,
                brideName,
                copiedDate,
                overAllStatus,
                pendingStatus,
                dataStatus,
                nasProcessStatusName,


              } = user
              acc.push([
                sNo,
                leadNo,
                companyName,
                branchName,
                clientName,
                crmName,
                mobileNo,
                cpProfile,
                cpRemarks,
                eventName,
                eventDate,
                groomName,
                brideName,
                copiedDate,
                overAllStatus,
                pendingStatus,
                dataStatus,
                nasProcessStatusName,

              ])

              return acc
            }, [])

          downloadFile({
            data: [...headerData, ...usersCsv].join("\n"),
            fileName: "CopyData.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 1500)
        return response.data
      })
      .catch((error) => {
        Promise.reject(error)
        setDownloadLoading(false)
      })
  }

  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          // sort,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="index"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4"></Col>
                      <Col
                        md="8"
                        style={{ marginBottom: "20px", marginTop: "-41px" }}
                      >
                        <div
                          style={{
                            float: "right",
                          }}
                        >
                          <Button
                            className="btn btn-info"
                            onClick={() => setColumnModal(true)}
                          >
                            Edit Columns
                          </Button>
                        </div>
                        <div
                          style={{
                            float: "right",
                            marginRight: "10px",
                          }}
                        >
                          {" "}
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      </Col>

                      <Col>
                        <BootstrapTable
                          remote
                          keyField="index"
                          data={data}
                          id="ImportTable"
                          noDataIndication={"No Data Found..."}
                          columns={columns}
                          responsive
                          expandRow={expandRow}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone {...paginationProps} />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
  const [pageLoad, setPageLoad] = useState(false)
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: data_copy_details.length,
    data:
      !isEmpty(data_copy_details) && data_copy_details.length > 0
        ? data_copy_details.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (
    type,
    { page, sortField, sortOrder, currentIndex, sizePerPage }
  ) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    let result =
      !isEmpty(data_copy_details) && data_copy_details.length > 0
        ? data_copy_details
        : []
    if (
      !isEmpty(copyData.fromDate) ||
      !isEmpty(copyData.toDate) ||
      !isEmpty(copyData.leadNo)
    ) {

      var searchFromDate =
        copyData && copyData.fromDate
          ? moment(copyData.fromDate).format("YYYY-MM-DD")
          : ""
      var searchToDate =
        copyData && copyData.toDate
          ? moment(copyData.toDate).format("YYYY-MM-DD")
          : ""
      var searchLeadNo = copyData && copyData.leadNo ? copyData.leadNo : ""

      var searchvalue = {}
      searchvalue.page = page
      searchvalue.limit = sizePerPage ? sizePerPage : 50

      if (searchFromDate) {
        searchvalue.eventStartDate = searchFromDate
      }
      if (searchToDate) {
        searchvalue.eventEndDate = searchToDate
      }
      if (searchLeadNo) {
        searchvalue.leadNo = searchLeadNo
      }

      setPageLoad(!pageLoad)
      setLoading(true)
      specificDispatch(copyDataAction.loadDataCopy(searchvalue))
    } else {
      dispatch(
        copyDataAction.loadDataCopy({
          page: page,
          limit: sizePerPage,
        })
      )
      setLoading(true)
      setPageLoad(!pageLoad)
    }

    setTimeout(() => {
      setLoading(false)
    }, 2000)
    if (sortOrder === "asc") {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return 1
        } else if (b[sortField] > a[sortField]) {
          return -1
        }
        return 0
      })
    } else {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return -1
        } else if (b[sortField] > a[sortField]) {
          return 1
        }
        return 0
      })
    }

    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }

  //expand row functionality from bootstrap table
  const [updateModal, setUpdateModal] = useState(false)
  const expandRow = {
    renderer: (row) => (
      <>
        <Table bordered>
          <thead>
            <tr>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Code
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Date
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Service Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Type
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Shooter Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Service Level Status Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                File Count
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Size
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Remarks
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Copied Date
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Created By
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Created On
              </th>

            </tr>
          </thead>
          <tbody>
            {row && !isEmpty(row.serviceDetails) && row.serviceDetails.length > 0 ?
              (row.serviceDetails.map((data, index) => {

                return (
                  <tr key={index}>
                    <th scope="data">{data.eventName ? data.eventName : "--"}</th>
                    <td>{data.eventCode ? data.eventCode : "--"}</td>
                    <td>{data.eventDate ? moment(data.eventDate).format(dateFormat) : "--"}</td>
                    <td>{data.serviceName ? data.serviceName : "--"}</td>
                    <td>{data.teamType ? data.teamType : "--"}</td>
                    <td>{data.teamType == "InHouse" ? data.teamEmployeeShooterName
                      : data.temType == "Freelancer" ?
                        data.teamFreelanceShooter && !isEmpty(data.teamFreelanceShooter) ?
                          data.teamFreelanceShooter.map(m => m.freelanceMainShooterName).join(",") : "--" : "--"}</td>
                    <td>{data.serviceLevelStatusName ? data.serviceLevelStatusName : "--"}</td>
                    <th>{data.fileCount ? data.fileCount : "--"}</th>
                    <td>{data.size ? data.size : "--"}</td>
                    <td>{data.remarks ? data.remarks : "--"}</td>
                    <td>{data.copiedDate != undefined && data.copiedDate != null ? moment(data.copiedDate).format(dateFormat) : '--'}</td>
                    <td>{data.creadtedByName ? data.creadtedByName : "--"}</td>
                    <td>{data.createdAt != undefined && data.createdAt != null ? moment(data.createdAt).format(dateFormat) : "--"}</td>
                  </tr>
                )
              }

              )) : (
                <tr key={0}>
                  <td className="text-align-center" colSpan={13}>
                    No Results found
                  </td>
                </tr>
              )}
          </tbody>
        </Table>
      </>
    ),
    showExpandColumn: true,
    expandByColumnOnly: true,
    onlyOneExpanding: true,
  }

  const handleNasModal = () => {
    setUpdateLinkModal(false)
  }


  const uploadApproval = () => {
    const formValid = simpleUploadValidator.current.allValid()
    if (formValid) {
      const qcDetails = {
        leadId: leadId,
        processStatus: "PS76",
        processStatusName: "UPLOAD LINK QC APPROVED",
        remarks: uploadQcData.description

      }
      dispatch(copyDataAction.uploadQc(qcDetails))
      setTimeout(() => {
        dispatch(
          copyDataAction.loadDataCopy(searchValue)
        )
        toast.success("Approved successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
        handleHideMessages()
        setUpdateModal(false)
      }, 1000)
    } else {
      simpleUploadValidator.current.showMessages()
      setRenderPage(!renderPage)
      forceUpload(1)
    }
  }

  const uploadRecheck = () => {
    const formValid = simpleUploadValidator.current.allValid()
    if (formValid) {
      const qcDetails = {
        leadId: leadId,
        processStatus: "PS77",
        processStatusName: "UPLOAD LINK QC RECHECK",
        remarks: uploadQcData.description

      }
      dispatch(copyDataAction.uploadQc(qcDetails))
      setTimeout(() => {
        dispatch(
          copyDataAction.loadDataCopy(searchValue)
        )
        toast.success("Approved successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
        handleHideMessages()
        setUpdateModal(false)
      }, 1000)
    } else {
      simpleUploadValidator.current.showMessages()
      setRenderPage(!renderPage)
      forceUpload(1)
    }
  }
  const deleteStatus = () => {
    const deleteData = {
      "leadId": leadId,
      "dataDeleteRemarks": deleteStatusData.remarks
    }
    dispatch(copyDataAction.deleteStatus(deleteData))
    setTimeout(() => {
      dispatch(
        copyDataAction.loadDataCopy(searchValue)
      )
      toast.success("Delete Status Updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
      setDeleteStatusModal(false)
    }, 1000)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title={"Operaions"} breadcrumbItem={title} />

          {/*form start */}
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"Lead No"}
                          </Label>
                        </div>
                        <Input
                          type="text"
                          placeholder="Enter Lead No"
                          name="leadNo"
                          value={copyData.leadNo}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event From Date"}
                          >
                            {"Event From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="fromDate"
                          value={copyData.fromDate}
                          max={copyData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"Event To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="toDate"
                          value={copyData.toDate}
                          min={copyData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>

                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            onClick={(e) => applyFilter(e)}
                            className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <div
                    className="d-flex flex-row"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                      <form onSubmit={handleClick} className="d-flex flex-row">
                        <div style={searchBtnStyle || null}>
                          <Input
                            type="text"
                            name="searchInput"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="form-control"
                            placeholder="Search"
                            style={{ position: "relative" }}
                          />
                          <i
                            className="bx bx-search-alt"
                            style={{
                              position: "absolute",
                              top: "54px",
                              left: "41px",
                              fontSize: "13px",
                            }}
                          />
                        </div>
                        <button
                          className="btn btn-success mx-2"
                          type="submit"
                          style={{
                            background: searchFilter ? "#2ca67a" : "",
                            color: searchFilter ? "#ffffff" : "",
                          }}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </form>
                    </div>
                  </div>{" "}
                  <RemotePagination
                    data={copyDataTable}
                    page={page}
                    sizePerPage={sizePerPage}
                    totalSize={
                      !isEmpty(data_copy_details)
                        ? data_copy_details.totalDataCount
                        : 0
                    }
                    onTableChange={handleTableChange}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {updateModal && (
          <Modal show={updateModal} size="md">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Upload QC</span>
              </div>

            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col sm="12" md="12" xl="12" lg="12">
                  <div className="d-flex justify-content-between">
                    <Label
                      className="form-label"
                      htmlFor={"Event To Date"}
                    >
                      {"Description"}<span className="required ms-1">*</span>
                    </Label>
                  </div>
                  <Input
                    type="textarea"
                    placeholder="Enter Description"
                    name="description"
                    value={uploadQcData.description}
                    onChange={(e) => handleQC(e)}
                  />
                  <div style={{ textTransform: "capitalize" }}>
                    {simpleUploadValidator.current.message(
                      "Description",
                      uploadQcData.description,
                      "required"
                    )}
                  </div>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <div>
                <Button
                  // type="submit"
                  onClick={() => {
                    setUpdateModal(false)
                  }}
                  className="btn btn-danger buttons"
                >
                  {" "}
                  Cancel
                </Button>
                <Button
                  style={{ marginLeft: "10px" }}
                  onClick={() => {

                    uploadApproval()
                  }}
                  className="btn btn-success buttons"
                >
                  {" "}
                  Approval
                </Button>
                <Button
                  type="submit"
                  onClick={() => {

                    uploadRecheck()
                  }}
                  style={{ marginLeft: "10px" }}
                  className="btn btn-warning buttons"
                >
                  {" "}
                  Recheck
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
        {updateLinkModal && (
          <Modal show={updateLinkModal} onHide={handleNasModal} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Nas Link
              <span>
                <i
                  className="fa fa-times quote-close"
                  aria-hidden="true"
                  onClick={() => setUpdateLinkModal(false)}
                  style={{ color: "white" }}
                ></i>
              </span>
            </Modal.Header>
            <Modal.Body>
              <Row>

                <Col md="12" lg="12" xl="12" className="mt-2">
                  <Table striped bordered>
                    <thead>
                      <tr style={{ fontSize: "10px" }}>
                        {/* <th>S.No</th> */}
                        <th style={{ width: "7%" }}>S.No</th>
                        <th style={{ width: "10%" }}>Folder Type</th>
                        <th style={{ width: "15%" }}>Status</th>
                        <th style={{ width: "10%" }}>File Count</th>
                        <th style={{ width: "10%" }}>Size</th>
                        <th style={{ width: "25%" }}>Link</th>
                        <th style={{ width: "15%" }}>Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data_link_details && !isEmpty(data_link_details) && data_link_details.length > 0 ?
                        data_link_details.map((item, index) => {

                          return (<tr key={index}>
                            <td>{index + 1}</td>

                            <td>{item.folderType}</td>
                            <td>{item.serviceLevelStatusId != null ? item.serviceLevelStatusId.serviceLevelName : ""}</td>
                            <td>{item.fileCount ? item.fileCount : "--"}</td>
                            <td>{item.size ? item.size : "--"}</td>
                            <td>{item.link ? item.link : "--"}</td>
                            <td>{item.remarks ? item.remarks : "--"}</td>
                          </tr>
                          )
                        }) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={7}>
                              No data found
                            </td>
                          </tr>
                        )}

                    </tbody></Table>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>

              <Button
                className="btn btn-danger"
                onClick={() => setUpdateLinkModal(false)}
                style={{ marginRight: "15px" }}
              >
                Close
              </Button>

            </Modal.Footer>
          </Modal>
        )}
        {columnModal && (
          <Modal size="xl" show={columnModal}>
            <Modal.Header
              style={{
                backgroundColor: "white",
                color: "black",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Edit Columns
              <span>
                <i
                  className="fa fa-times quote-close"
                  aria-hidden="true"
                  onClick={() => setColumnModal(false)}
                ></i>
              </span>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <div>
                  <Input
                    type="checkbox"
                    checked={selectedColumns.length === columns.length}
                    onChange={(e) => handleSelectAllChange(e)}
                    style={{ width: "15px", height: "15px" }}
                  />
                  <Label style={{ fontSize: "16px", marginLeft: "10px" }}>
                    Select All
                  </Label>
                </div>
              </Row>
              <Row>
                <Col sm="12" md="6" lg="6" className="ml-4">
                  {oddColumnData.map((column) => (
                    <div key={column.dataField} className="d-flex flex-row">
                      <div className="form-check form-check-inline">
                        <Input
                          type="checkbox"
                          value={column.dataField}
                          checked={selectedColumns.includes(column.dataField)}
                          onChange={(e) => handleCheckboxChange(e)}
                          style={{ width: "15px", height: "15px" }}
                        />
                        <Label
                          style={{
                            fontSize: "16px",
                            marginLeft: "10px",
                          }}
                        >
                          {column.text}
                        </Label>
                      </div>
                    </div>
                  ))}
                </Col>
                <Col sm="12" md="6" lg="6">
                  {evenColumnData.map((column) => (
                    <div key={column.dataField} className="d-flex flex-row">
                      <div className="form-check form-check-inline">
                        <Input
                          type="checkbox"
                          value={column.dataField}
                          checked={selectedColumns.includes(column.dataField)}
                          onChange={(e) => handleCheckboxChange(e)}
                          style={{ width: "15px", height: "15px" }}
                        />
                        <Label
                          style={{
                            fontSize: "16px",
                            marginLeft: "10px",
                          }}
                        >
                          {column.text}
                        </Label>
                      </div>
                    </div>
                  ))}
                </Col>
              </Row>
            </Modal.Body>

            <Modal.Footer>
              <p
                className="text-decoration-underline text-info"
                style={{ cursor: "pointer", fontSize: "16px" }}
                onClick={handleRestoreToDefault}
              >
                Restore To Default
              </p>
              <Button
                variant="secondary"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => {
                  setColumnModal(false)
                  setSelectedColumns(selectColumn)
                }}
              >
                Close
              </Button>
              <Button
                variant="primary"
                className="btn btn-success"
                onClick={() => handleSaveColumns()}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {btnLoading ? (
          <Modal show={btnLoading} style={{ width: "7%", margin: "18% 50%" }}>
            <Modal.Body>
              <Spinner
                as="span"
                animation="grow"
                size="lg"
                role="status"
                aria-hidden="true"
                variant="success"
                className="mx-2"
                color="success"
              />
            </Modal.Body>
          </Modal>
        ) : (
          ""
        )}
        {loading ? (
          <Modal show={loading} style={{ width: "7%", margin: "18% 50%" }}>
            <Modal.Body>
              <Spinner
                as="span"
                animation="grow"
                size="lg"
                role="status"
                aria-hidden="true"
                variant="success"
                className="mx-2"
                color="success"
              />
            </Modal.Body>
          </Modal>
        ) : (
          ""
        )}
        {downloadLoading ? (
          <Modal
            show={downloadLoading}
            style={{ width: "7%", margin: "18% 50%" }}
          >
            <Modal.Body>
              <Spinner
                as="span"
                animation="grow"
                size="lg"
                role="status"
                aria-hidden="true"
                variant="success"
                className="mx-2"
                color="success"
              />
            </Modal.Body>
          </Modal>
        ) : (
          ""
        )}

        {pendingModal && (
          <Modal size="xl" show={pendingModal}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Pending Status
            </Modal.Header>
            <Modal.Body>


              <Row className="mt-3">
                <Table>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Event Name</th>
                      <th>Event Date</th>
                      <th>Service Name</th>
                      <th>Type</th>
                      <th>Name</th>
                      <th>Status</th>
                      <th>File Count</th>
                      <th>File Size</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>

                  <tbody>
                    {!isEmpty(pendingData) &&
                      pendingData.length > 0 ? (
                      pendingData.map((data, index) => {
                        const typeName = data.type != "InHouse" ? data.freelancerName : data.EmployeName

                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{data.eventName ? data.eventName : "--"}</td>
                            <td>{data.eventDate ? moment(data.eventDate).format(dateFormat) : "--"}</td>
                            <td>{data.serviceName ? data.serviceName : "--"}</td>
                            <td>{data.type ? data.type : "--"}</td>
                            <td>{typeName}</td>
                            <td>{data.status ? data.status : "--"}</td>
                            <td>
                              {data.fileCount ? data.fileCount : "--"}
                            </td>
                            <td>{data.size ? data.size : "--"}</td>
                            <td>{data.remarks ? data.remarks : "--"}</td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr>
                        <td className="text-align-center" colSpan={10}>
                          No Records Found...
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Row>

            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => setPendingModal(false)}
              >
                Close
              </Button>

            </Modal.Footer>
          </Modal>
        )}
        {deleteStatusModal && (
          <Modal size="md" show={deleteStatusModal}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Delete Status
            </Modal.Header>
            <Modal.Body>
              <Row className="mb-5">

                <Col md="12" lg="12" xl="12" sm="12" className="mt-1">
                  <div className="d-flex justify-content-between">
                    <Label className={"form-label"} htmlFor={"remarks"}>
                      {"Remarks"}
                    </Label>
                  </div>
                  <Input
                    type="textarea"
                    name="remarks"
                    value={deleteStatusData.remarks}
                    onChange={(e) => handleDeleteChange(e)}
                    placeholder="Enter Remarks"
                  />
                </Col>
              </Row>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => setDeleteStatusModal(false)}
              >
                Cancel
              </Button>

              <Button
                type="submit"
                variant="secondary"
                className={"btn btn-success"}
                data-bs-dismiss="modal"
                onClick={(e) => deleteStatus(e)}
              >
                update
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </React.Fragment>
  )
}

DataCopyDeleted.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  csvProps: PropTypes.any,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
  pageClick: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  //mapstate to props
})
//DataCopyDeleted
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DataCopyDeleted)
)
